import SharedTranslations, { TranslationField } from "shared/components/Translations";
import { LocaleCode } from "shared/types/languages";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { useStudioDetails } from '../../context';
import { ManagedTranslations } from "../../context/types";

const Translations = () => {
  const { studioName, studioDescription, translations, setTranslations } = useStudioDetails();

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.Name,
      label: "Title",
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? studioName?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              studioName?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
    {
      key: ManagedTranslations.Description,
      label: "Description",
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? studioDescription?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              studioDescription?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;
